// UserInfoQuestionSetRewardsTab.js
import React, { useState, useRef, useEffect } from "react";
import { 
  Row, 
  Col, 
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
} from "reactstrap";
import { withTranslation } from "react-i18next";
import axiosInstance from "utils/axiosInstance";

// Select and DND
import Select, { components } from 'react-select';
import { Plus } from "react-feather";

const booleanOptions = [
  { value: true, label: "有" },
  { value: false, label: "沒有" }
];

const QuestionSetRewardsTab = ({
  t,
  infoQuestionSetId,
  infoQuestionSet,
  setInfoQuestionSet,
  setError,
}) => {

  //--------------------------------------------------
  // States
  //--------------------------------------------------
  const [openSelectId, setOpenSelectId] = useState(null);

  const [hasPointRewardMarker, setHasPointRewardMarker] = useState(false);
  const [pointRewardAmount, setPointRewardAmount] = useState(0);
  const [savingHasPointReward, setSavingHasPointReward] = useState(false);
  const [savedHasPointReward, setSavedHasPointReward] = useState(true);

  useEffect(()=>{
    setHasPointRewardMarker(infoQuestionSet?.pointReward?.hasReward);
    setPointRewardAmount(infoQuestionSet?.pointReward?.amount);
  },[infoQuestionSet])
  
  const savePointRewardSettings = async (newState, newAmount) => {
    setSavingHasPointReward(true);
    setSavedHasPointReward(false);

    try {
      await axiosInstance.patch(`/knovia/myInfo/userInfoQuestionSet/${infoQuestionSetId}/updatePointReward`, {
        hasPointReward: newState,
        pointRewardAmount: newState ? newAmount : 0
      });

      setInfoQuestionSet(prev => ({
        ...prev,
        pointReward: {
          hasReward: newState,
          amount: newState ? newAmount : 0
        }
      }));

      setSavedHasPointReward(true);
    } catch (err) {
      console.error("Save failed (point reward):", err);
    } finally {
      setSavingHasPointReward(false);
    }
  }

  return (

    <Row className="mb-4">
      <Col xs={12}>
        <h5>有題組獎勵？</h5>
        <Col className="mb-2">
          {savingHasPointReward && <span style={{ color: "#f1b34c" }}>Saving...</span>}
          {!savingHasPointReward && 
            <span style={{ color: savedHasPointReward ? "#34c38f" : "#aeabab" }}>✔ Saved!</span>
          }
        </Col>
        <Row className="align-items-center mb-2">
          <Col xs={12} md={6} xl={5} className="mb-2">
            <Select
              value={booleanOptions.find(opt => opt.value === hasPointRewardMarker)}
              onChange={({ value }) => {
                setHasPointRewardMarker(value);
                if (!value) {
                  setPointRewardAmount(0);
                  savePointRewardSettings(false, "");
                } else {
                  setSavedHasPointReward(false);
                }
              }}
              options={booleanOptions}
              isSearchable={false}
            />
          </Col>

          <Col xl={12}></Col>

          {hasPointRewardMarker && (
            <>
              <Col xs={12} md={2} xl={2} className="d-flex align-items-center">
                <p className="mb-0" style={{ minWidth: "100px", whiteSpace: "nowrap" }}>
                  獎勵點數數量
                </p>
              </Col>
              <Col xs={9} md={3} xl={2} className="d-flex align-items-center">
                <div className="d-flex flex-column" style={{ flexGrow: "1" }}>
                  <Input
                    type="number"
                    min="1"
                    max="30"
                    placeholder="輸入數量"
                    value={pointRewardAmount}
                    onChange={(e) => {
                      let raw = e.target.value;

                      // Allow empty string to reset
                      if (raw === '') {
                        setPointRewardAmount('');
                        return;
                      }

                      // Remove leading zeros and parse to number
                      let value = parseInt(raw, 10);

                      if (isNaN(value)) {
                        setPointRewardAmount('');
                      } else {
                        if (value < 1) value = 1;
                        if (value > 30) value = 30;
                        setPointRewardAmount(String(value)); // convert back to string to strip leading zeros
                      }
                    }}
                  />
                  {(pointRewardAmount < 1 || pointRewardAmount > 30) && (
                    <small className="text-danger">請輸入 1 到 30 之間的數字</small>
                  )}
                </div>
              </Col>
              <Col xs={3} md={1} xl={1} className="d-flex align-items-center">
                <Button
                  color="outline-success"
                  style={{ padding: "7px 8px", marginLeft: "20px" }}
                  onClick={() => { savePointRewardSettings(true, pointRewardAmount); }}
                  disabled={pointRewardAmount===0 || savingHasPointReward}
                >
                  <i className="bx bx-check"/>
                </Button>
              </Col>
            </>
          )}
        </Row>
      </Col>
    </Row>

  );
};

export default withTranslation()(QuestionSetRewardsTab);


